import { useFarol }             from '../../contexts/FarolPageContext';
import { useUser }              from '../../contexts/UserContext';
import FarolCard                from './FarolCard'; 
import api                      from '../../services/api.js';
import { findPermission }       from '../../utils/UserPermissionUtils.js';
import { useEffect, useState }  from 'react';

function FarolCardsContainer({ 

        faroTerminalId, 
        terminalName, 
        isShipDockered, 
        description, 
        shipDescription, 
        farols,
        isStacked

    }) {

        const { userData } = useUser()

        const [ _hasPermission, _setHasPermission ] = useState(false)
        const [ _isAddingFarol, _setAddingFarol   ] = useState(false)

        const {

            handleUpdateFarolCards

        } = useFarol()

        const _handleDeleteCard = async (faroTerminalId) => {
            
            try {
                
                const response = await api.delete(`/deleteFarolTerminal/${faroTerminalId}`);

                if (response.status === 204) handleUpdateFarolCards()

            } catch (error) {

                console.error('Error deleting farol terminal:', error);

            }
            
        }

        // "Adicionar" abre uma linha vazia em edição na lista, sem formulário.
        const _handleCreateFarol = () => _setAddingFarol(true)

        // Navio e descrição editados direto no card.
        const _handleUpdateField = async (field, value) => {

            try {

                await api.put(`/updateFarolTerminal/${faroTerminalId}`, { newData: { [field]: value } })
                handleUpdateFarolCards()

            } catch (error) {

                console.error('Error updating farol terminal:', error);

            }
        }

        useEffect(() => {

            const hasPermission = findPermission(userData, "Edição Dados dos Faróis")
            
            _setHasPermission(hasPermission)

        }, [userData])
        
    return (
        <>
            
            <FarolCard

                faroTerminalId={faroTerminalId} 
                terminalName={terminalName} 
                isShipDockered={isShipDockered}
                description={description}
                shipDescription={shipDescription}
                farols={farols}

                handleDeleteCard={_handleDeleteCard}
                handleCreateFarol={_handleCreateFarol}
                handleUpdateField={_handleUpdateField}

                isAddingFarol={_isAddingFarol}
                handleAddingFarolDone={() => _setAddingFarol(false)}


                hasPermission={_hasPermission}
                isStacked={isStacked}

            />
        </>
        
    )
}


export default FarolCardsContainer;